exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".trading-hours_switch-label{margin-left:10px}.invalid>.trading-hours_input-label:after{content:\"The entered trading hours are invalid!\"}", "", {"version":3,"sources":["/./node_modules/bambora-trading-hours/assets/node_modules/bambora-trading-hours/assets/index.css"],"names":[],"mappings":"AAAA,4BAA4B,gBAAgB,CAAC,0CAA0C,gDAAgD,CAAE","file":"index.css","sourcesContent":[".trading-hours_switch-label{margin-left:10px}.invalid>.trading-hours_input-label:after{content:\"The entered trading hours are invalid!\"}"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/postcss-loader!./~/sass-loader?sourceMap!./~/bambora-trading-hours/assets/index.css
// module id = 973
// module chunks = 0